import * as C from '../constants';

export default {
  /**
   * @param state
   * @param payload
   */
  [C.NAV_SET_BREADCRUMBS](state, payload) {
    state.breadcrumbs = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/mutations.js